import React from "react";
import Slider from "react-slick";

function PodcastNextArrow({ onClick }) {
  return (
    <button
      type="button"
      className="podcast-slider-next"
      onClick={onClick}
      aria-label="View next podcast image"
    >
      <i className="fa-solid fa-arrow-right" />
    </button>
  );
}

export default function PodcastSliderSection({ data }) {
  if (!data?.items?.length) {
    return null;
  }

  const settings = {
    arrows: true,
    dots: false,
    infinite: data.items.length > 3,
    autoplay: false,
    speed: 700,
    slidesToShow: 4,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "10vw",
    pauseOnHover: true,
    nextArrow: <PodcastNextArrow />,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          centerPadding: "7vw",
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          centerPadding: "38px",
        },
      },
    ],
  };

  return (
    <section className="podcast-slider-section">
      <Slider {...settings} className="podcast-slider">
        {data.items.map((item) => (
          <div className="slide-item" key={item.image}>
            <img
              src={item.image}
              alt={item.imageAlt || "Podcast slider"}
              className="img-responsive"
            />
          </div>
        ))}
      </Slider>
    </section>
  );
}
